import React from "react";
import styled from "styled-components";
import Checkboxes from "./Checkboxes.tsx";
import Range from "./Range.tsx";

const Wrapper = styled.div`
  min-width: 12rem;
  display: flex;
  flex-direction: column;
  gap: 1rem;
`;

const Title = styled.div`
  border-bottom: 1px solid rgba(0, 0, 0, 0.2);
  font-size: 1.2rem;
  padding: 1rem 0 0.5rem 0;
  color: var(--tertiary-font-color);
  font-family: Georgia, serif;
`;

interface Props {
  title?: string;
  sections: {
    title: string;
    type: string;
    items: any;
    isExpanded: boolean;
    selectedValues?: string[];
    onChange: (selectedValues: string[] | string) => void;
  }[];
}

const Filterbar: React.FC<Props> = ({ title, sections }) => {
  return (
    <Wrapper>
      {title && <Title>{title}</Title>}
      {sections.map((section, index) => {
        if (!section.items || section.items.length === 0) {
          return null;
        }
        if (section.type === "checkbox") {
          return (
            <Checkboxes
              selectedValues={section.selectedValues || []}
              onChange={section.onChange || (() => {})}
              key={`${section.title}-${section.selectedValues?.join(",")}`}
              label={section.title}
              name={section.title}
              options={section.items}
              isExpanded={section.isExpanded}
            />
          );
        }
        if (section.type === "range") {
          return (
            <Range
              onChange={section.onChange}
              key={`${section.title}-${section.selectedValues || ""}`}
              label={section.title}
              name={section.title}
              options={section.items}
              isExpanded={section.isExpanded}
            />
          );
        }
        return null;
      })}
    </Wrapper>
  );
};

export default Filterbar;
